import { type Dispatch } from "@reduxjs/toolkit";

import * as groupsOverviewActionTypes from "./groupsOverviewActionTypes";
import dataService from "../../../../Application/services/dataServices/dataService";
import { makeActionCreator } from "../../../../Application/actions/actionsBuilder";
import { type Enrollment, type SortingDirection } from "enums";
import { escapeTerm } from "utils/searchUtils";

export type FetchGroupsPayload = {
  skip: number;
  top: number;
  sortBy?: string;
  sortOrder?: SortingDirection;
  isOpen?: number;
  term?: string;
  isTemplate?: boolean;
  isWithAutoEnroll?: Enrollment;
};

const takeCount = process.env.REACT_APP_LOAD_ITEMS_COUNT;
const isCanceledError = (err: any) => err.code === "ERR_CANCELED";

export const setGroupsFilter = makeActionCreator(groupsOverviewActionTypes.GROUPS_SET_ITEMS_FILTER, "filter");

export const resetGroupsFilter = makeActionCreator(groupsOverviewActionTypes.GROUPS_RESET_ITEMS_FILTER);

export const resetGridItems = makeActionCreator(groupsOverviewActionTypes.FETCH_GROUPS_LAZY.RESET_GRID_ITEMS);

export const fetchGroups = ({ top, skip, ...rest }: FetchGroupsPayload) => {
  const fetchGroupsBegin = makeActionCreator(groupsOverviewActionTypes.FETCH_GROUPS.FETCH_ITEMS_BEGIN);

  const fetchGroupsSuccess = makeActionCreator(
    groupsOverviewActionTypes.FETCH_GROUPS.FETCH_ITEMS_SUCCESS,
    "items",
    "itemsCount",
  );

  const fetchGroupsFailure = makeActionCreator(groupsOverviewActionTypes.FETCH_GROUPS.FETCH_ITEMS_FAILURE, "error");

  return async (dispatch: Dispatch) => {
    dispatch(fetchGroupsBegin());
    try {
      if (rest.term) {
        rest.term = escapeTerm(rest.term.trim());
      }
      const result = await dataService.getGroupsV2({
        skip,
        top,
        ...rest,
      });
      dispatch(fetchGroupsSuccess(result.items, result.count));
    } catch (error) {
      if (!isCanceledError(error)) dispatch(fetchGroupsFailure(error));
    }
  };
};

export const fetchGroupsLazy = ({ skip, ...rest }: Omit<FetchGroupsPayload, "top">) => {
  const fetchGroupsBegin = makeActionCreator(groupsOverviewActionTypes.FETCH_GROUPS_LAZY.FETCH_GRID_ITEMS_BEGIN);

  const fetchGroupsSuccess = makeActionCreator(
    groupsOverviewActionTypes.FETCH_GROUPS_LAZY.FETCH_GRID_ITEMS_SUCCESS,
    "items",
    "itemsCount",
  );
  const fetchGroupsFailure = makeActionCreator(
    groupsOverviewActionTypes.FETCH_GROUPS_LAZY.FETCH_GRID_ITEMS_FAILURE,
    "error",
  );

  return async (dispatch: Dispatch) => {
    dispatch(fetchGroupsBegin());
    try {
      const result = await dataService.getGroupsV2({
        ...rest,
        skip,
        top: takeCount,
      });
      dispatch(fetchGroupsSuccess(result.items, result.count));
    } catch (error) {
      if (!isCanceledError(error)) dispatch(fetchGroupsFailure(error));
    }
  };
};
